import type { ReactNode } from "react";

type Props = { className?: string };

function Stroke({ className, children }: Props & { children: ReactNode }) {
  return <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden className={className}>{children}</svg>;
}

export function BrowserIcon(props: Props) {
  return <Stroke {...props}><rect x="2.5" y="3" width="15" height="14" rx="2"/><path d="M2.5 7h15M6 5h.01M9 5h.01"/></Stroke>;
}

export function FlowsIcon(props: Props) {
  return <Stroke {...props}><rect x="3" y="3" width="14" height="14" rx="1.5"/><path d="M6 7h8M6 10.5h8M6 14h4"/></Stroke>;
}

export function AgentIcon(props: Props) {
  return <Stroke {...props}><rect x="3" y="5.5" width="14" height="11.5" rx="2"/><path d="M10 2.5v3M6.5 10h.01M13.5 10h.01M7 14h6"/></Stroke>;
}

export function AgentCheckIcon(props: Props) {
  return <Stroke {...props}><path d="m3.5 10.5 4 4 9-9"/></Stroke>;
}

export function EmptyDeskIcon(props: Props) {
  return <Stroke {...props}><path d="M3 14.5h14M5 14.5l1.5-6h7l1.5 6M7.5 5.5h5"/></Stroke>;
}
